function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function elementIsVisible(element) {
	var position = element.getBoundingClientRect();
  var position_bottom = position.bottom;
  if (element.offsetHeight >= window.innerHeight) {
    position_bottom = position.bottom - 500;
  }
	if(position.top >= 0 && position_bottom <= window.innerHeight) {
		return true;
	}
}

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "{{amount}}€";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ' ');
    decimal   = defaultOption(decimal, ',');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.money_format_number = "{{amount}}";
Shopify.formatMoneyNumber = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format_number);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ' ');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', '.');
      break;
  }

  return parseFloat(formatString.replace(placeholderRegex, value));
};

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}




// class QuantityInput extends HTMLElement {
//   constructor() {
//     super();
//     this.input = this.querySelector('input');
//     this.changeEvent = new Event('change', { bubbles: true })

//     this.querySelectorAll('button').forEach(
//       (button) => button.addEventListener('click', this.onButtonClick.bind(this))
//     );
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     const previousValue = this.input.value;

//     event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
//     if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
//   }
// }

// customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    document.querySelector('.product-media-modal').addEventListener(
      'click',
      this.hide.bind(this, true),
    );
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false),
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


class CartManager {
  constructor() {
    let self = undefined;

    const CART_REQUEST_TYPES = {
      ADD: 'add',
      UPDATE: 'update',
      CHANGE: 'change',
      REMOVE: 'remove',
      CLEAR: 'clear',
    };

    this.cart_request_type = CART_REQUEST_TYPES;
  }

  async getCart() {
    var shopifyCart = await this.fetchCart();
    var cart = JSON.parse(JSON.stringify(shopifyCart));
    return cart;
  }
  async getCartGTM() {
    var shopifyCart = await this.fetchCartGTM();
    var cart = JSON.parse(JSON.stringify(shopifyCart));
    return cart;
  }

  async updateNote(note, options) {
    const formData = {
      note: note,
    };
    return this.postShopify(formData, this.cart_request_type.UPDATE, {
      onSuccess:
        options && typeof options.onSuccess === 'function'
          ? options.onSuccess
          : function () {},
      onFailure:
        options && typeof options.onFailure === 'function'
          ? options.onFailure
          : function () {},
      always:
        options && typeof options.always === 'function'
          ? options.always
          : function () {},
    });
  }

  handleErrors(options) {
    const errorMessage =
      options.status + ' ' + options.message + ' ' + options.description;
    return errorMessage;
  }

  async addItem(variant_id, quantity, properties, options) {
    const formData = {
      items: [
        {
          id: variant_id,
          quantity: quantity,
          properties: properties,
        },
      ],
    };
    this.postShopify.bind(this)(formData, 'add', options);
  }

  updateItems(requests, onAllExecuted) {
    if (!Array.isArray(requests)) requests = [requests];
    let shopifyRequestsList = [];
    // In update requests we can add many items, as a map of id/key:quantity
    let shopifyUpdateRequest = {
      updates: {},
    };
    // In add requests we can add many items, as an object
    let shopifyAddRequest = {
      items: [],
    };
    for (let request of requests) {
      let action = request.type;
      let items = request.items;
      if (action == this.cart_request_type.ADD) {
        for (let item of items) {
          if (!item.id || isNaN(item.quantity)) {
            console.error(
              'To add a new item both properties: ID & QUANTITY are required',
              item,
            );
            continue;
          }

          let cartItem = {
            id: item.id,
            quantity: item.quantity,
          };
          if (typeof item.properties == 'object' && item.properties != null)
            cartItem.properties = item.properties;

          shopifyAddRequest.items.push(cartItem);
        }
      } else if (action == this.cart_request_type.UPDATE) {
        for (let item of items) {
          if (!item.key || isNaN(item.quantity)) {
            console.error(
              'To update an existing item, both properties: KEY & QUANTITY are required',
              item,
            );
            continue;
          }

          let cartItem = {
            id: item.key,
            quantity: item.quantity,
          };
          if (typeof item.properties == 'object' && item.properties != null)
            cartItem.properties = item.properties;

          // TODO: Test if a normal item can be converted to a subscription using the change request.

          if (cartItem.properties)
            shopifyRequestsList.push({
              type: this.cart_request_type.CHANGE,
              body: cartItem,
            });
          else shopifyUpdateRequest.updates[cartItem.id] = cartItem.quantity;
        }
      } else if (action == this.cart_request_type.REMOVE) {
        for (let item of items) {
          if (!item.key) {
            console.error('To remove an existing item KEY is required', item);
            continue;
          }

          shopifyUpdateRequest.updates[item.key] = 0;
        }
      }
    }
    if (Object.keys(shopifyUpdateRequest.updates).length)
      shopifyRequestsList.push({
        type: this.cart_request_type.UPDATE,
        body: shopifyUpdateRequest,
      });
    if (shopifyAddRequest.items.length)
      shopifyRequestsList.push({
        type: this.cart_request_type.ADD,
        body: shopifyAddRequest,
      });

    let requestsCount = Object.keys(shopifyRequestsList).length;
    let onFinishedContext = {requests_count: requestsCount};
    let onFinished = function () {
      --this.requests_count;
      if (!this.requests_count && typeof onAllExecuted === 'function')
        onAllExecuted();
    }.bind(onFinishedContext);

    for (let shopifyRequest of shopifyRequestsList) {
      this.postShopify(shopifyRequest.body, shopifyRequest.type, onFinished);
    }
  }

  clearCart() {
    const formData = {};
    this.postShopify.bind(this)(formData, 'clear');
  }

  postShopify(formData, action, options) {
    var self = this;
    var url = false;

    // Create a queue if it is not created yet.
    if (!Array.isArray(self.requestsQueue)) self.requestsQueue = [];

    // Add the new request at the beginning of queue.
    const newRequest = {
      formData,
      action,
      options,
    };
    self.requestsQueue.unshift(newRequest);

    // Replace the current request (queued at the end) with the next request in line.
    const currentRequest = self.requestsQueue.pop();
    formData = currentRequest.formData;
    action = currentRequest.action;
    options = currentRequest.options || {};

    if (!options.onSuccess || typeof options.onSuccess !== 'function')
      options.onSuccess = function () {};
    if (!options.onFailure || typeof options.onFailure !== 'function')
      options.onFailure = function () {};
    if (!options.always || typeof options.always !== 'function')
      options.always = function () {};

    if (action == this.cart_request_type.ADD) {
      url = window.routes.cartAddJS;
    } else if (action == this.cart_request_type.UPDATE) {
      url = window.routes.cartUpdateJS;
    } else if (action == this.cart_request_type.CHANGE) {
      url = window.routes.cartChangeJS;
    } else if (action == this.cart_request_type.CLEAR) {
      url = window.routes.cartClearJS;
    }
    // Ignore request as it doesn't match any of the available actions
    // If there are still requests in the queue, handle the next in line.
    else if (self.requestsQueue.length) {
      const nextRequest = self.requestsQueue.pop();
      return self.postShopify(
        nextRequest.formData,
        nextRequest.action,
        nextRequest.options,
      );
    }
    // Otherwise, end execution.
    else
      return console.error(
        `Can't post to Shopify. The action: ${action} is not valid`,
      );

    // Execute request
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
      },
      body: JSON.stringify(formData),
    })
      .then(function (response) {
        if (response.ok) return response.json();
        throw Error(response.statusText);
      })
      .then(function (cart) {
        try {
          options.onSuccess();
        } catch (e) {
          console.error(
            'Error executing onSuccess callback from postShopify',
            e,
          );
        }

        return {cart};
      })
      .catch(function (error) {
        self.handleErrors(error);

        try {
          options.onFailure();
        } catch (e) {
          console.error(
            'Error executing onFailure callback from postShopify',
            e,
          );
        }

        return {err: error};
      })
      .finally(function () {
        try {
          options.always();
        } catch (e) {
          console.error('Error executing always callback from postShopify', e);
        }

        // Handle next request if there are any in the queue.
        if (self.requestsQueue.length) {
          const nextRequest = self.requestsQueue.pop();
          return self.postShopify(nextRequest.formData, nextRequest.action);
        }
      });
  }

  async fetchCart(async) {
    var req = fetch(window.routes.cartJSON);

    if (async) {
      return req.then((response) => response.json());
    } else {
      var res = await req;
      return await res.json();
    }
  }
  async fetchCartGTM(async) {
    var req = fetch(window.routes.cartJSONGTM);

    if (async) {
      return req.then((response) => response.json());
    } else {
      var res = await req;
      return await res.json();
    }
  }
}

const cartManager = new CartManager();

customElements.define(
  'cart-remove-button',
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();

      this.removeEvent = new Event('remove', {bubbles: true});
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.dispatchEvent(this.removeEvent);
      });
    }
  },
);

customElements.define(
  'cart-items',
  class CartItems extends HTMLElement {
    constructor() {
      super();

      const selectors = {
        cartNotification: 'cart-notification',
        variantSelects: 'variant-selects',
      };

      this.selectors = selectors;
      this.cartNotifications = document.querySelectorAll(
        this.selectors.cartNotification,
      );
      this.variantSelects = document.querySelectorAll(
        this.selectors.variantSelects,
      );

      this.currentItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]'),
      ).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value),
        0,
      );

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.addEventListener('remove', (event) => {
        this.updateQuantity(
          event.target.dataset.index,
          0,
          event.target.dataset.key,
          document.activeElement.getAttribute('name'),
          "remove",
          (event.target.dataset != null && event.target.dataset.removeGift != null) ? this.removeGift.bind(this) : "",
        );
      });
    }

     removeGift() {
      console.log("removeGift");
    }

    onChange(event) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        event.target.dataset.key,
        document.activeElement.getAttribute('name'),
        event.detail
      );
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items') != null
                    ? document.getElementById('main-cart-items').dataset.id
                    : null,
          selector: '[data-items-cart]',
        },
        {
          id: 'main-cart-summary',
          section: document.getElementById('main-cart-summary') != null
                    ? document.getElementById('main-cart-summary').dataset.id
                    : null,
          selector: '.cart-drawer-summary',
        },
        {
          id: 'drawer-cart-footer',
          section: document.getElementById('drawer-cart-footer') != null
                    ? document.getElementById('drawer-cart-footer').dataset.id
                    : null,
          selector: '[data-cart-total-price]',
        },
        {
          id: 'drawer-cart-upsell',
          section:
            document.getElementById('drawer-cart-upsell') != null
              ? document.getElementById('drawer-cart-upsell').dataset.id
              : null,
          selector: '[data-upsell-cart-drawer]',
        },
        {
          id: 'drawer-cart-upsell-dynamic',
          section:
            document.getElementById('drawer-cart-upsell-dynamic') != null
              ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
              : null,
          selector: '[data-upsell-dynamic-cart-drawer]',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer') != null
                    ? document.getElementById('main-cart-footer').dataset.id
                    : null,
          selector: '.main-cart__footer',
        }
      ];
    }

    updateQuantity(line, quantity, variantID, name, action, callback) {
      this.enableLoading(line);
      console.log(action);

      localStorage.removeItem('cartView');

      localStorage.setItem('productUpdated', true);

      if (quantity == 0) {
        var button = this.querySelector(`#CartItem-${line}`).querySelector('[data-product-datalayer]');
        var dataGTM = JSON.parse(button.dataset.productDatalayer);

        var dataEvent = dataGTM;
  
        var evt = new CustomEvent("gtmRemoveCart", {'detail': dataEvent});
        window.dispatchEvent(evt);
      }

      if (action == "minus" && quantity != 0) {
        var button = this.querySelector(`#CartItem-${line}`).querySelector('[data-product-datalayer]');
        var dataGTM = JSON.parse(button.dataset.productDatalayerQuantity);

        var dataEvent = dataGTM;
  
        var evt = new CustomEvent("gtmRemoveCart", {'detail': dataEvent});
        window.dispatchEvent(evt);
      }

      if (action == "plus") {
        var button = this.querySelector(`#CartItem-${line}`).querySelector('[data-product-datalayer]');
        var dataGTM = JSON.parse(button.dataset.productDatalayerQuantity);

        var dataEvent = dataGTM;
  
        var evt = new CustomEvent("gtmAddToCartSidecart", {'detail': dataEvent});
        window.dispatchEvent(evt);
      }

      const body = JSON.stringify({
        id: variantID,
        quantity: quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch('/cart/change', {...fetchConfig(), ...{body}})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          
          //
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter)
            cartFooter.classList.toggle(
              'is-empty',
              parsedState.item_count === 0,
            );

          this.cartNotifications.forEach((section) => {
            section.updateItemsCount(parsedState.item_count);
          });

          this.variantSelects.forEach((section) => {
            section.reset();
          });

          this.getSectionsToRender().forEach((section) => {
            if(section.section != null) {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);
              if (elementToReplace != null) {
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector,
                );
              }
            }
          });

          const lineItem = document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`))
            lineItem.querySelector(`[name="${name}"]`).focus();
          this.disableLoading(line);

          if (callback && typeof callback == 'function') {
            callback();
          };
        })
        .catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) =>
            overlay.classList.add('hidden'),
          );
          this.disableLoading(line);
        });
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      document
        .getElementById('main-cart-items')
        .classList.add('cart__items--disabled');
      this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
        (overlay) => overlay.classList.remove('hidden'),
      );
      this.querySelector(`#CartItem-${line}`).classList.add('updating');
      document.activeElement.blur();
    }

    disableLoading(line) {
      document
        .getElementById('main-cart-items')
        .classList.remove('cart__items--disabled');
        if (this.querySelector(`#CartItem-${line}`) != null) {
          this.querySelector(`#CartItem-${line}`).classList.remove('updating');
        }
    }
  },
);


customElements.define(
  'cart-upsell-dynamic',
  class CartItems extends HTMLElement {
    constructor() {
      super();

      const selectors = {
        cartNotification: 'cart-notification',
        addUpsellDynamic: '[data-add-upsell-dynamic]',
        addUpsellDynamicTarget: 'data-add-upsell-dynamic-target',
        addUpsellDynamicProduct: 'data-add-upsell-dynamic-product',
        addUpsellDynamicQuantity: 'data-add-upsell-dynamic-quantity',
        addUpsellDynamicSellingPlan: 'data-add-upsell-dynamic-selling-plan',
      };

      this.selectors = selectors;
      this.cartNotifications = document.querySelectorAll(
        this.selectors.cartNotification,
      );

      this.addUpsellDynamics = document.querySelectorAll(
        this.selectors.addUpsellDynamic,
      );

      this.cartItems = document.querySelector('cart-items');

      this.addUpsellDynamics.forEach((addUpsellDynamic) => {
        addUpsellDynamic.addEventListener('click', (event) => {
          this.addUpsellDynamic(
            event.target.dataset.addUpsellDynamicTarget,
            event.target.dataset.addUpsellDynamicProduct,
            event.target.dataset.addUpsellDynamicQuantity,
            (event.target.dataset.addUpsellDynamicSellingPlan != undefined) ? event.target.dataset.addUpsellDynamicSellingPlan: '',
            event.target
          );
        });
      });

    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items') != null
                    ? document.getElementById('main-cart-items').dataset.id
                    : null,
          selector: '[data-items-cart]',
        },
        {
          id: 'main-cart-summary',
          section: document.getElementById('main-cart-summary') != null
                    ? document.getElementById('main-cart-summary').dataset.id
                    : null,
          selector: '.cart-drawer-summary',
        },
        {
          id: 'drawer-cart-footer',
          section: document.getElementById('drawer-cart-footer') != null
                    ? document.getElementById('drawer-cart-footer').dataset.id
                    : null,
          selector: '[data-cart-total-price]',
        },
        {
          id: 'drawer-cart-upsell-dynamic',
          section:
            document.getElementById('drawer-cart-upsell-dynamic') != null
              ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
              : null,
          selector: '[data-upsell-dynamic-cart-drawer]',
        }
      ];
    }

    async addUpsellDynamic(oldProduct, newProduct, quantity, selling_plan, submitButton) {

      localStorage.setItem('upsellAdded', true);

      const body = JSON.stringify({
        id: oldProduct,
        quantity: 0
      });

      await this.updateItemById(oldProduct, 0);

      var sections = this.getSectionsToRender().map((section) => section.section);
      var sections_url = window.location.pathname;
      await this.addItem(newProduct, quantity, selling_plan, submitButton);

    }

    async addItem(variantId, quantity, selling_plan, submitButton) {
      const result = await fetch("/cart/add", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify({
              id: variantId,
              quantity: quantity,
              selling_plan: selling_plan,
              properties: {
                "_is_upsell": true,
                "_item_selection": "up-sell"
              }
          })
      }).then((response) => {
        return response.text();
      })
      .then(async (state) => {
        
        //
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);

        this.cartNotifications.forEach((section) => {
          var q = section.getItemsCount();
          section.updateItemsCount(parseInt(q) + parseInt(quantity));
        });

        var dataEvent = {
          "item_name":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('item_name'),
          "item_id":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('item_id'),
          "item_barcode":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('item_barcode'),
          "item_category":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('item_category'),
          "item_category2":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('item_category2'),
          "item_variant":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('item_variant'),
          "pack":"na",
          "product_related1":"na",
          "product_related2":"na",
          "price":submitButton === null || submitButton === void 0 ? void 0 : parseFloat(submitButton.getAttribute('price')),
          "currency":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('currency'),
          "item_selection": submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('item_selection'),
          "discount":submitButton === null || submitButton === void 0 ? void 0 : parseFloat(submitButton.getAttribute('discount')),
        };
  
        var evt = new CustomEvent("gtmAddToCart", {'detail': dataEvent});
        window.dispatchEvent(evt);

        const shopifyCartGTM = await cartManager.getCartGTM();

        console.log(shopifyCartGTM);
        var items = [];
        for (let index = 0; index < shopifyCartGTM.items.length; index++) {
          items.push({
            "index": shopifyCartGTM.items[index].index,
            "item_name": shopifyCartGTM.items[index].title,
            "item_id": shopifyCartGTM.items[index].sku,
            "item_barcode": shopifyCartGTM.items[index].product_id,
            "item_category": shopifyCartGTM.items[index].item_category,
            "item_category2": shopifyCartGTM.items[index].item_category2,
            "item_variant": shopifyCartGTM.items[index].item_variant,
            "pack": shopifyCartGTM.items[index].pack,
            "product_related1": shopifyCartGTM.items[index].product_related1,
            "product_related2": shopifyCartGTM.items[index].product_related2,
            "price": Shopify.formatMoneyNumber(shopifyCartGTM.items[index].original_price),
            "quantity": shopifyCartGTM.items[index].quantity,
            "item_selection":(shopifyCartGTM.items[index].properties != null && shopifyCartGTM.items[index].properties._item_selection != null) ? shopifyCartGTM.items[index].properties._item_selection : "usual",
            "discount": (shopifyCartGTM.items[index].properties != null && shopifyCartGTM.items[index].properties._pack != null) ? Shopify.formatMoneyNumber(shopifyCartGTM.items[index].total_discount) : (shopifyCartGTM.items[index].discounts != 0) ? Shopify.formatMoneyNumber(shopifyCartGTM.items[index].discounts) : 0,
          })
        };
  
        var dataEvent_2 = {
          value: Shopify.formatMoneyNumber(shopifyCartGTM.total_price),
          items: items
        };
  
        var evt_2 = new CustomEvent("gtmviewCart", {'detail': dataEvent_2});
        window.dispatchEvent(evt_2);
  
        var dataEvent = {
          "page_type_1": "funnel",
          "page_type_2": "cart",
          "category_1": "na",
          "category_2": "na",
          "environment": datalayer_environment,
          "language": datalayer_language,
          "hashed_256_email": datalayer_hashed_256_email,
          "customer_id": datalayer_customer_id,
          "user_status_login": datalayer_user_status_login,
          "nl_subscriber": datalayer_nl_subscriber
        };
  
        var evt = new CustomEvent("gtmPageviewCart", {'detail': dataEvent});
        window.dispatchEvent(evt);

        this.getSectionsToRender().forEach((section) => {
          if(section.section != null) {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);
            if (elementToReplace != null) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector,
              );
            }
          }
        });

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) =>
          overlay.classList.add('hidden'),
        );
      });
    }

    async init() {
      await fetch('/?sections=cart-drawer-v2', {
        method: 'GET',
      })
        .then((response) => response.json())
        .then((response) => {
          const doc = new DOMParser().parseFromString(
            response['cart-drawer-v2'],
            'text/html',
          );
          var contentUpdated = doc.querySelector('#drawer-cart-upsell-dynamic').innerHTML;
          this.innerHTML = contentUpdated;

        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    async updateItem(data) {
      const result = await fetch("/cart/change", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify(data)
      }).then((response) => {
        return response.text();
      })
      .then((state) => {

        var button = this.cartItems.querySelector(`[data-key="${data.id}"]`);
        var dataGTM = JSON.parse(button.dataset.productDatalayer);

        var dataEvent = dataGTM;
  
        var evt = new CustomEvent("gtmRemoveCart", {'detail': dataEvent});
        window.dispatchEvent(evt);
      });
    }
    
    updateItemById(lineItemId, newQuantity, newProperties = {}) {
        return this.updateItem({
            id: lineItemId,
            quantity: newQuantity,
            properties: newProperties
        });
    }
  

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

  },
);

customElements.define(
  'quantity-input',
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');

      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this)),
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.target.name === 'plus'
        ? this.input.stepUp()
        : this.input.stepDown();
      if (previousValue !== this.input.value)
        this.input.dispatchEvent(new CustomEvent('change', {bubbles: true, detail: event.target.name}));
    }
  },
);

customElements.define(
  'cart-notification',
  class CartNotification extends HTMLElement {
    constructor() {
      super();

      const selectors = {
        cartCount: '[data-cart-count]',
      };
      this.selectors = selectors;
      this.cartNotification = this.querySelector(this.selectors.cartCount);
    }

    updateItemsCount(itemsCount) {
      if (!this.cartNotification) return;

      this.cartNotification.innerHTML = itemsCount;
    }

    getItemsCount() {
      if (!this.cartNotification) return;
      return this.cartNotification.innerHTML;
    }
  },
);

customElements.define(
  'cart-progress-bar-gift',
  class progressbarGift extends HTMLElement {
  constructor() {
    super();

    let selectors = {
      treshold : "[data-progress-treshold]",
      tresholdData : "progressTreshold",
      price : "[data-progress-price]",
      priceFree : "[data-progress-price-free]",
      priceData : "[data-progress-treshold-price]",
      progressBar : "[data-progress-bar]",
      addToCart : "[data-add-progress-bar-gift]",
      productVariantID : "addProgressBarGiftProduct",
    };

    this.selectors = selectors;

    this.progressTreshold = this.querySelector(this.selectors.treshold);
    this.progressTresholdData = this.querySelector(this.selectors.treshold).dataset[this.selectors.tresholdData];
    this.progressPrice = this.querySelector(this.selectors.price);
    this.progressPriceFree = this.querySelector(this.selectors.priceFree);
    this.progressPriceData = this.querySelector(this.selectors.priceData);
    this.progressBar = this.querySelector(this.selectors.progressBar);
    this.productVariantID = this.querySelector(this.selectors.addToCart).dataset[this.selectors.productVariantID];
    this.addToCart = this.querySelector(this.selectors.addToCart);

    this.addToCart.addEventListener('click', (event) => {
      this.addToCart.disabled = true;
      this.addItem(this.productVariantID, {"_is_reward": true});
    });

    // this.init();
  }

  async init() {

      const cart = await cartManager.getCart();

      var ifGiftIsInCart = false;
      for (let index = 0; index < cart.items.length; index++) {
        if (cart.items[index].variant_id == this.productVariantID) {
          ifGiftIsInCart = true;
        }
      }

      if (ifGiftIsInCart) {
        this.classList.add('hide');
      } else {
        this.classList.remove('hide');
      }

      var price = (parseInt(this.progressTresholdData) - cart.items_subtotal_price);
      (price > 0) ? price : price = 0;
      
      this.progressPriceData.innerHTML =  Shopify.formatMoney(price);

      var pourcentage = (cart.items_subtotal_price * 100 / parseInt(this.progressTresholdData));

      if (pourcentage < 100) {
        this.progressBar.style.width = pourcentage + "%";
        this.progressPrice.classList.remove('hidden');
        this.progressPriceFree.classList.add('hidden');
        if (localStorage.getItem('giftAddedAuto')) {
          localStorage.removeItem('giftAddedAuto', true);
        }
      } else {
        this.progressBar.style.width = "100%";
        this.progressPrice.classList.add('hidden');
        this.progressPriceFree.classList.remove('hidden');
        if (!ifGiftIsInCart) {
          if (localStorage.getItem('giftAddedAuto') == null || localStorage.getItem('giftAddedAuto') != this.productVariantID) {
            this.addItem(this.productVariantID, {"_is_reward": true, "_added_auto": true, "_reward_threshold": parseInt(this.progressTresholdData)});
            localStorage.setItem('giftAddedAuto', this.productVariantID);
          }
        }
      }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items') != null
                  ? document.getElementById('main-cart-items').dataset.id
                  : null,
        selector: '[data-items-cart]',
      },
      {
        id: 'main-cart-summary',
        section: document.getElementById('main-cart-summary') != null
                  ? document.getElementById('main-cart-summary').dataset.id
                  : null,
        selector: '.cart-drawer-summary',
      },
      {
        id: 'drawer-cart-footer',
        section: document.getElementById('drawer-cart-footer') != null
                  ? document.getElementById('drawer-cart-footer').dataset.id
                  : null,
        selector: '[data-cart-total-price]',
      },
      {
        id: 'drawer-cart-upsell-dynamic',
        section:
          document.getElementById('drawer-cart-upsell-dynamic') != null
            ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
            : null,
        selector: '[data-upsell-dynamic-cart-drawer]',
      }
    ];
  }

  async addItem(variantId, props) {

    var propsToPass = {};
    if (props) {
      propsToPass = props;
    }
    
    const result = await fetch("/cart/add", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: propsToPass
        })
    }).then((response) => {
      return response.text();
    })
    .then((state) => {
      
      //
      this.addToCart.disabled = false;
      const parsedState = JSON.parse(state);
      this.classList.toggle('is-empty', parsedState.item_count === 0);

      this.cartNotifications.forEach((section) => {
        var q = section.getItemsCount();
        section.updateItemsCount(parseInt(q) + parseInt(quantity));
      });

      this.getSectionsToRender().forEach((section) => {
        if(section.section != null) {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          if (elementToReplace != null) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector,
            );
          }
        }
      });

    })
    .catch(() => {
      this.querySelectorAll('.loading-overlay').forEach((overlay) =>
        overlay.classList.add('hidden'),
      );
    });
  }
});


customElements.define(
  'cart-drawer',
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      const selectors = {
        cartOpen: '[data-cart-drawer-open]',
        cartClose: '[data-cart-drawer-close]',
        cartDrawer: 'cart-drawer-v2',
        cartOverlay: 'cart-overlay',
        cartNotification: 'cart-notification',
        cartUpsellDynamic: 'cart-upsell-dynamic',
        cartProgressBarGift: 'cart-progress-bar-gift',
      };

      this.selectors = selectors;
      this.cartDrawer = document.getElementById(this.selectors.cartDrawer);
      this.cartOverlay = document.getElementById(this.selectors.cartOverlay);
      this.cartNotifications = document.querySelectorAll(
        this.selectors.cartNotification,
      );
      this.cartUpsellDynamic = document.querySelector(
        this.selectors.cartUpsellDynamic,
      );
      this.cartProgressBarGift = document.querySelector(
        this.selectors.cartProgressBarGift,
      );

      this.cartDrawer.addEventListener(
        'keyup',
        (evt) => evt.code === 'Escape' && this.close(),
      );

      document
        .querySelectorAll(this.selectors.cartOpen)
        .forEach((cartOpen) =>
          cartOpen.addEventListener('click', this.handleCartUpdates.bind(this), false),
        );

      this.init();
    }

    init() {
      // Detect cart interactions
      this.httpInterceptor(
        [
          '/cart/add',
          '/cart/add',
          '/cart/change',
          // '/cart/update',
          '/cart/clear',
        ],
        this.handleCartUpdates.bind(this),
      );
    }

    async open() {


      if (localStorage.getItem('cartView') == null) {
        localStorage.setItem('cartView', true);

        const shopifyCartGTM = await cartManager.getCartGTM();

        console.log(shopifyCartGTM);
        var items = [];
        for (let index = 0; index < shopifyCartGTM.items.length; index++) {
          items.push({
            "index": shopifyCartGTM.items[index].index,
            "item_name": shopifyCartGTM.items[index].title,
            "item_id": shopifyCartGTM.items[index].sku,
            "item_barcode": shopifyCartGTM.items[index].product_id,
            "item_category": shopifyCartGTM.items[index].item_category,
            "item_category2": shopifyCartGTM.items[index].item_category2,
            "item_variant": shopifyCartGTM.items[index].item_variant,
            "pack": shopifyCartGTM.items[index].pack,
            "product_related1": shopifyCartGTM.items[index].product_related1,
            "product_related2": shopifyCartGTM.items[index].product_related2,
            "price": Shopify.formatMoneyNumber(shopifyCartGTM.items[index].original_price),
            "quantity": shopifyCartGTM.items[index].quantity,
            "item_selection":(shopifyCartGTM.items[index].properties != null && shopifyCartGTM.items[index].properties._item_selection != null) ? shopifyCartGTM.items[index].properties._item_selection : "usual",
            "discount": (shopifyCartGTM.items[index].properties != null && shopifyCartGTM.items[index].properties._pack != null) ? Shopify.formatMoneyNumber(shopifyCartGTM.items[index].total_discount) : (shopifyCartGTM.items[index].discounts != 0) ? Shopify.formatMoneyNumber(shopifyCartGTM.items[index].discounts) : 0,
          })
        };
  
        var dataEvent_2 = {
          value: Shopify.formatMoneyNumber(shopifyCartGTM.total_price),
          items: items
        };
  
        var evt_2 = new CustomEvent("gtmviewCart", {'detail': dataEvent_2});
        window.dispatchEvent(evt_2);
  
        var dataEvent = {
          "page_type_1": "funnel",
          "page_type_2": "cart",
          "category_1": "na",
          "category_2": "na",
          "environment": datalayer_environment,
          "language": datalayer_language,
          "hashed_256_email": datalayer_hashed_256_email,
          "customer_id": datalayer_customer_id,
          "user_status_login": datalayer_user_status_login,
          "nl_subscriber": datalayer_nl_subscriber
        };
  
        var evt = new CustomEvent("gtmPageviewCart", {'detail': dataEvent});
        window.dispatchEvent(evt);
      }

      this.cartDrawer.classList.add('animate', 'active');
      this.cartOverlay.classList.add('animate', 'active');
    }

    close() {
      this.cartDrawer.classList.remove('active');
      this.cartOverlay.classList.remove('active');

      localStorage.removeItem('cartView');

      if (window.location.href.indexOf('/cart') > -1) {
        window.location.href = "/"
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items') != null
                    ? document.getElementById('main-cart-items').dataset.id
                    : null,
          selector: '[data-items-cart]',
        },
        {
          id: 'main-cart-summary',
          section: document.getElementById('main-cart-summary') != null
                    ? document.getElementById('main-cart-summary').dataset.id
                    : null,
          selector: '.cart-drawer-summary',
        },
        {
          id: 'drawer-cart-footer',
          section: document.getElementById('drawer-cart-footer') != null
                    ? document.getElementById('drawer-cart-footer').dataset.id
                    : null,
          selector: '[data-cart-total-price]',
        },
        {
          id: 'drawer-cart-upsell-dynamic',
          section:
            document.getElementById('drawer-cart-upsell-dynamic') != null
              ? document.getElementById('drawer-cart-upsell-dynamic').dataset.id
              : null,
          selector: '[data-upsell-dynamic-cart-drawer]',
        },
        {
          id: 'drawer-cart-progress-bar-gift-empty',
          section:
            document.querySelector('[data-progress-bar-gift-cart-drawer-empty]') != null
              ? document.querySelector('[data-progress-bar-gift-cart-drawer-empty]')
              : null,
          selector: '[data-progress-bar-gift-cart-drawer]',
        }
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    async renderContents(refreshContentsAllow) {
      await fetch('/?sections=cart-drawer-v2', {
        method: 'GET',
      })
        .then((response) => response.json())
        .then((response) => {
          // const doc = new DOMParser().parseFromString(
          //   response['cart-drawer-v2'],
          //   'text/html',
          // );
          // var contentUpdated = doc.querySelector('#cart-drawer-v2').innerHTML;
          // this.cartDrawer.innerHTML = contentUpdated;

          this.getSectionsToRender().forEach((section) => {
            if(section.section != null) {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);
              if (elementToReplace != null) {
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  response["cart-drawer-v2"],
                  section.selector,
                );
              }
            }
          });

          document
            .querySelectorAll(this.selectors.cartClose)
            .forEach((cartClose) =>
              cartClose.addEventListener('click', this.close.bind(this)),
            );

            if(document.querySelector('#drawer-cart-progress-bar-gift-empty') != null) {
              this.cartProgressBarGift = document.querySelector('#drawer-cart-progress-bar-gift-empty cart-progress-bar-gift');
              this.cartProgressBarGift.init();
            }
          
        })
        .catch((error) => {
          console.error('Error:', error);
        });

      this.open();
      this.initCGU();
    }

    initCGU() {
      var checkoutCGU = this.cartDrawer.querySelector('#checkbox_cgu');
      if(checkoutCGU == null) return;

      var checkoutButton = this.cartDrawer.querySelector('[data-checkout-cart-drawer]');
      var checkoutCGUError = this.cartDrawer.querySelector('.cart-drawer-checkbox-error');
      checkoutButton.addEventListener('click', function(e) {
        if (checkoutCGU.checked) {
          window.location = Shopify.routes.root + "checkout";
        } else {
          checkoutCGUError.classList.add('active');
        }
      });

    }

    async addGhostProduct(variantId) {
      localStorage.setItem('ghostProductIsAdding', true);
      const result = await fetch("/cart/add", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify({
              id: variantId,
              quantity: 1,
              properties: {
                "_is_ghost_product": true
              }
          })
      }).then((response) => {
        return response.text();
      })
      .then((state) => {
        if (localStorage.getItem('ghostProductIsAdding')) {
          localStorage.removeItem('ghostProductIsAdding');
        }
      })
      .catch(() => {

      });
    }

    async removeGhostProduct(variantId) {
      const result = await fetch("/cart/change", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify({
              id: variantId.toString(),
              quantity: 0
          })
      }).then((response) => {
        return response.text();
      })
      .then((state) => {
        

  
      })
      .catch(() => {

      });
    }

    async handleCartUpdates(res, url) {
      if (res != undefined && res.target != undefined && res.target) {
        res.preventDefault();
      }
      const shopifyCart = await cartManager.getCart();
      this.cartNotifications.forEach((section) => {
        section.updateItemsCount(shopifyCart.item_count);
      });
      
      if (this.cartProgressBarGift != null) {
        this.cartProgressBarGift.init();
      }
      let refreshContentsAllow = true;

      if (localStorage.getItem('noteUpdated')) {
        localStorage.removeItem('noteUpdated');
        refreshContentsAllow = false;
      }
      if (localStorage.getItem('productUpdated')) {
        localStorage.removeItem('productUpdated');
        refreshContentsAllow = true;
      }
      if (localStorage.getItem('upsellAdded')) {
        localStorage.removeItem('upsellAdded');
        refreshContentsAllow = false;
      }

       // Logique d'ajout d'un produit gratuit pour les abonnés, pour faire apparaitre les modes de livraison
       if(window.location.href.includes("https://www.lashilebeauty.com/")) {

        console.log('Cart ', shopifyCart);
        var onlySubscription = true;
        var foundGhostProduct = false;
        var ghostProductVariantId = 41871711830202;
 
        for (let index = 0; index < shopifyCart.items.length; index++) {
         let item = shopifyCart.items[index];
         if(!item.selling_plan_allocation && item.variant_id != ghostProductVariantId) onlySubscription = false;
         if(item.variant_id == ghostProductVariantId) foundGhostProduct = true;
        }
 
        console.log("onlySubscription");
        console.log(onlySubscription);

       // Add ghost product if only subscription item(s) in cart
       if(onlySubscription && !foundGhostProduct && shopifyCart.items.length > 0 && !localStorage.getItem('ghostProductIsAdding')) {
        console.log('add');
        await this.addGhostProduct(ghostProductVariantId);
       }

       // Remove ghost product if non subscription item(s) in cart
       if(!onlySubscription && foundGhostProduct && shopifyCart.items.length > 0) {
        console.log('remove');
        await this.removeGhostProduct(ghostProductVariantId);
        refreshContentsAllow = true;
       }

       // Remove ghost product if only this ghost product in cart
       if(foundGhostProduct && shopifyCart.items.length == 1) {
        console.log('remove');
        await this.removeGhostProduct(ghostProductVariantId);
        refreshContentsAllow = true;
       }

       if (foundGhostProduct) {
        this.cartNotifications.forEach((section) => {
          section.updateItemsCount(shopifyCart.item_count - 1);
        });
       }
      }

      if (refreshContentsAllow) {
        await this.renderContents(refreshContentsAllow);
      }
    }

    async httpInterceptor(urlmatchs, callback) {
      var responseMatchesAnyUrl = function (requestUrl, urls) {
        if (!Array.isArray(urls)) urls = [urls];

        for (const url of urls) {
          if (!requestUrl.includes(url)) continue;
          return true;
        }

        return false;
      };

      // Intercept fetch.
      const constantMock = window.fetch;
      window.fetch = function () {
        return new Promise((resolve, reject) => {
          constantMock
            .apply(this, arguments)
            .then(async (response) => {
              try {
                if (
                  responseMatchesAnyUrl(response.url, urlmatchs) &&
                  response.type != 'cors' &&
                  response.ok
                ) {
                  let json = await response.clone().json();
                  if (typeof callback === 'function')
                    await callback(json, response.url);
                }
              } catch (err) {
                console.error(
                  'Something went wrong while intercepting cart update',
                  err,
                );
              }
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      };

      // Intercept Ajax.
      let send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        this.addEventListener(
          'readystatechange',
          async function () {
            if (
              responseMatchesAnyUrl(this.responseURL, urlmatchs) &&
              this.readyState === 4 &&
              this.status == 200
            ) {
              if (typeof callback === 'function')
                await callback(JSON.parse(this.response), this.responseURL);
            }
          },
          false,
        );
        send.apply(this, arguments);
      };

      // TODO: Listen to HTML form submits.
      // Intercept HTML Forms.
      document.addEventListener(
        'submit',
        function (e) {
          // Valid the target.
          if (
            !e.target ||
            e.target.tagName.toLowerCase() !== 'form' ||
            e.target.matches('[sz-no-block]')
          )
            return;
          // Validate the URL.
          var form = e.target;
          var submitButton = e.submitter;
          var actionUrl = new URL(form.action);
          var actionPath = actionUrl.pathname;
          if (!actionPath.includes('/cart')) return;

          e.preventDefault();
          this.cartDrawer = document.querySelector('cart-drawer');


          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.headers['Content-Type'] = "application/json";

          var quickAdd = document.querySelector("[data-quickadd-popup]");

          const formData = new FormData(form);
          var object = {};
          formData.forEach(function(value, key){
              object[key] = value;
          });
          var json = object;

          if (quickAdd && quickAdd.style.display == "block") {
            json.properties = { "_item_selection": "quick_access" };
          } else {
            json.properties = { "_item_selection": "usual" };
          }
          
          config.body = JSON.stringify(json);

          console.log(config.body);


          // Close quickadd popup
          
          if (quickAdd && quickAdd.style.display == "block") {
            var item_selection = "quick_access";
          } else {
            var item_selection = "usual";
          }
          if (quickAdd != undefined) quickAdd.style.display = "none";

          var isUpsell = false;
          if (submitButton.classList.contains('product-card-upsell_button')) {
            isUpsell = true;
          }

          var item_variant = "simple";
          if (formData.get('selling_plan') != '' && formData.get('selling_plan') != null) {
            item_variant = "VIP";
          }

          fetch(actionPath, config)
            .then((response) => response.json())
            .then(async function (response) {
              if (response.status) {
                console.log(response.description);
                return;
              }


              if (actionPath == "/cart/add" || actionPath == "/en/cart/add" || actionPath == "/nl-be/cart/add" ) {
                var dataEvent = {
                  "item_name":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('data-item_name'),
                  "item_id":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('data-item_id'),
                  "item_barcode":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('data-item_barcode'),
                  "item_category":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('data-item_category'),
                  "item_category2":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('data-item_category2'),
                  "item_variant":item_variant,
                  "pack":"na",
                  "product_related1":"na",
                  "product_related2":"na",
                  "price":submitButton === null || submitButton === void 0 ? void 0 : parseFloat(submitButton.getAttribute('data-price')),
                  "currency":submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('data-gtm-currency'),
                  "item_selection":item_selection,
                  "discount":submitButton === null || submitButton === void 0 ? void 0 : parseFloat(submitButton.getAttribute('data-discount')),
                };
          
                var evt = new CustomEvent("gtmAddToCart", {'detail': dataEvent});
                window.dispatchEvent(evt);
              }
  
              if (typeof callback === 'function')
                await callback(undefined, response);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {});
        }.bind(this),
      );
    }
  },
);

window.addEventListener('DOMContentLoaded', () => {
  var viewItemList = document.querySelectorAll('[data-gtm-view-item-list]');
  if (viewItemList.length > 0) {
    for (let index = 0; index < viewItemList.length; index++) {
      const element = viewItemList[index];
      window.addEventListener('scroll', function() {
        var sectionIsViewed = element.dataset.gtmViewItemListViewed;

        if (sectionIsViewed == 'false' && elementIsVisible(element)) {
          element.setAttribute('data-gtm-view-item-list-viewed', 'true');
          var dataEvent = JSON.parse(element.dataset.gtmViewItemList);
          var evt = new CustomEvent("gtmViewItemList", {'detail': dataEvent});
          window.dispatchEvent(evt);
        }
      }); 
    } 
  }

  var viewItemList = document.querySelectorAll('[data-gtm-view-item-list-search]');
  if (viewItemList.length > 0) {
    for (let index = 0; index < viewItemList.length; index++) {
      const element = viewItemList[index];
      var dataEvent = JSON.parse(element.dataset.gtmViewItemListSearch);
      var evt = new CustomEvent("gtmViewItemList", {'detail': dataEvent});
      window.dispatchEvent(evt);
    } 
  }
  var viewItemList = document.querySelectorAll('[data-gtm-view-item-list-essentiels]');
  if (viewItemList.length > 0) {
    for (let index = 0; index < viewItemList.length; index++) {
      const element = viewItemList[index];
      var dataEvent = JSON.parse(element.dataset.gtmViewItemListEssentiels);
      var evt = new CustomEvent("gtmViewItemList", {'detail': dataEvent});
      window.dispatchEvent(evt);
    } 
  }

  var clickItem = document.querySelectorAll('[data-gtm-select-item]');
  if (clickItem.length > 0) {
    for (let index = 0; index < clickItem.length; index++) {
      const element = clickItem[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = JSON.parse(element.dataset.gtmSelectItem);
        var evt = new CustomEvent("gtmViewSelectList", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  var logouts = document.querySelectorAll('[data-gtm-logout]');
  if (logouts.length > 0) {
    for (let index = 0; index < logouts.length; index++) {
      const element = logouts[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {};
        var evt = new CustomEvent("gtmLogout", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 2000);
      });
    }
  }

  var languageLinks = document.querySelectorAll('[data-gtm-language-link]');
  if (languageLinks.length > 0) {
    for (let index = 0; index < languageLinks.length; index++) {
      const element = languageLinks[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "position": e.target.getAttribute('data-gtm-language-link'),
          "country_status": langify.locale.iso_code + '_to_' + e.target.querySelector('.header--mobile__language-iso').innerHTML.toLowerCase()
        };
        var evt = new CustomEvent("gtmLanguageLinks", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  var contactPhone = document.querySelectorAll('[data-gtm-contact-phone]');
  if (contactPhone.length > 0) {
    for (let index = 0; index < contactPhone.length; index++) {
      const element = contactPhone[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {};
        var evt = new CustomEvent("gtmContactPhone", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  var contactMail = document.querySelectorAll('[data-gtm-contact-mail]');
  if (contactMail.length > 0) {
    for (let index = 0; index < contactMail.length; index++) {
      const element = contactMail[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {};
        var evt = new CustomEvent("gtmContactMail", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  var socialLinks = document.querySelectorAll('[data-gtm-click-social]');
  if (socialLinks.length > 0) {
    for (let index = 0; index < socialLinks.length; index++) {
      const element = socialLinks[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "social": e.target.getAttribute('data-gtm-click-social')
        };
        var evt = new CustomEvent("gtmSocialLinks", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  var packLinks = document.querySelectorAll('[data-gtm-click-pack]');
  if (packLinks.length > 0) {
    for (let index = 0; index < packLinks.length; index++) {
      const element = packLinks[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "cta_title": e.target.innerText
        };
        var evt = new CustomEvent("gtmPackLinks", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  var sliderLinks = document.querySelectorAll('[data-gtm-click-slider]');
  if (sliderLinks.length > 0) {
    for (let index = 0; index < sliderLinks.length; index++) {
      const element = sliderLinks[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "banner_name": e.target.getAttribute('data-gtm-click-slider'),
          "cta_title": e.target.innerText
        };
        var evt = new CustomEvent("gtmCtaSlider", {'detail': dataEvent});
        window.dispatchEvent(evt);        
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  var sliderDots = document.querySelectorAll('[data-gtm-click-slider-dot]');
  if (sliderDots.length > 0) {
    for (let index = 0; index < sliderDots.length; index++) {
      const element = sliderDots[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "banner_name": e.target.getAttribute('data-gtm-click-slider-dot'),
          "index": e.target.getAttribute('data-gtm-click-slider-dot-index'),
        };
        var evt = new CustomEvent("gtmSliderDot", {'detail': dataEvent});
        window.dispatchEvent(evt);
      });
    }
  }  
  
  var linksFooter = document.querySelectorAll('[data-gtm-click-link-footer]');
  if (linksFooter.length > 0) {
    for (let index = 0; index < linksFooter.length; index++) {
      const element = linksFooter[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "footer_menu": e.target.getAttribute('data-gtm-click-link-footer'),
        };
        var evt = new CustomEvent("gtmLinksFooter", {'detail': dataEvent});
        window.dispatchEvent(evt);
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }
  
  var linksMegaMenu = document.querySelectorAll('[data-gtm-click-link-mega-menu]');
  if (linksMegaMenu.length > 0) {
    for (let index = 0; index < linksMegaMenu.length; index++) {
      const element = linksMegaMenu[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "menu_level1": e.target.getAttribute('data-gtm-click-link-mega-menu'),
          "menu_level2": e.target.innerText
        };
        var evt = new CustomEvent("gtmLinksMegaMenu", {'detail': dataEvent});
        window.dispatchEvent(evt);
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }  

  var linksHeader = document.querySelectorAll('[data-gtm-click-link-header]');
  if (linksHeader.length > 0) {
    for (let index = 0; index < linksHeader.length; index++) {
      const element = linksHeader[index];
      element.addEventListener('click', function(e) {
        e.preventDefault();
        var dataEvent = {
          "menu_level1": e.target.innerText
        };
        var evt = new CustomEvent("gtmLinksHeader", {'detail': dataEvent});
        window.dispatchEvent(evt);
        setTimeout(function(){location.href = element.getAttribute("href")}, 1000);
      });
    }
  }

  // FIX LOOX REVIEWS
  var looxRatings = document.querySelectorAll('.loox-rating-label');
  looxRatings.forEach(function (looxRating){
      var str = looxRating.innerHTML.replace('&nbsp;', '');
      looxRating.innerHTML = str;
  });

});


